<template>
    <p class="my-8 flex flex-col pb-2 border-l-8 border-blue-900 pl-8">
        <span class="block text-3xl xl:text-4xl font-bold leading-relaxed text-blue-900">
            {{ block.Headline }}
        </span>
        <span class="block text-xl xl:text-2xl font-lighter leading-none text-blue-900">
            {{ block.SubHeadline }}
        </span>
    </p>
</template>

<script>
    export default {
        name: "Statistic",
        data() {
            return {
                block: {
                    Headline: '100%',
                    SubHeadline: 'Of statistics are made up'
                }
            }
        }
    };
</script>